import { RoomTypes } from '@weblite/ts-action/room'
import { subscriptionsStorage } from '$logic/subscription/storage'
import { showAccessToHallRestrictedBecauseOfPaymentModal } from '$comp/modals/access-to-hall-restricted-because-of-late-payment'

export async function ensureHallCallAccess(
  roomId: string,
  roomType: RoomTypes,
) {
  const subscription =
    subscriptionsStorage.getFromRedux(roomId) ||
    (await subscriptionsStorage.get(roomId))
  if (!subscription?.suspended) return true

  showAccessToHallRestrictedBecauseOfPaymentModal({
    hallType: roomType === 'GROUP' ? 'GROUP' : 'CHANNEL',
  })
  return false
}
